<form [formGroup]="copyProductForm" (ngSubmit)="onCopyProduct()">
  <div class="main-card">
    <div class="card-header">
      <a class="main-btn back-btn" [routerLink]="['./../']"
        ><i class="pi pi-angle-left m-0"></i
      ></a>
      <button class="main-btn" type="submit">
        Snimi <i class="pi pi-save"></i>
      </button>
    </div>
    <div class="grid">
      <div class="col-4">
        <h3 class="card-title">Kopiraj proizvod</h3>
      </div>
      <div class="col-4"></div>
      <div class="col-4">
        <h3 class="card-title">Statistika</h3>
      </div>
    </div>

    <div class="card-body">
      <div class="grid">
        <div class="col-4">
          <div class="field">
            <label>Šarža broj</label>
            <input type="text" formControlName="batch" pInputText />
          </div>
          <div class="field">
            <label>Šifra proizvoda</label>
            <input type="text" formControlName="label" pInputText />
          </div>
          <div class="field">
            <label>Naziv proizvoda</label>
            <input type="text" formControlName="name" pInputText />
          </div>
          <div class="field">
            <label>Tip</label>
            <p-dropdown
              [options]="productTypes"
              optionLabel="name"
              formControlName="product_type_id"
              optionValue="id"
              placeholder="Izaberi tip"
            ></p-dropdown>
          </div>
          <div class="field w-100">
            <label>Prosečno vreme</label>
            <input
              type="text"
              class="w-100"
              formControlName="total_estimated_time"
              pInputText
            />
          </div>
        </div>

        <div class="col-4">
          <div class="field">
            <label>Napomena</label>
            <textarea
              rows="13"
              cols="30"
              pInputTextarea
              autoResize="autoResize"
              formControlName="description"
            ></textarea>
          </div>
        </div>

        <div class="col-4">
          <p>Prosečno vreme izrade...</p>
          <p>Prosečni troškovi...</p>
        </div>
      </div>

      <div class="grid">
        <div class="col-12">
          <h3 class="card-title">Redosled operacija</h3>
        </div>

        <div class="col-12">
          <ul
            dragula="OPERATIONS"
            formArrayName="operations"
            [(dragulaModel)]="getOperationsControls.controls"
          >
            <li
              *ngFor="
                let operations of getOperationsControls.controls;
                let formGroupIndex = index
              "
              [formGroupName]="formGroupIndex"
            >
              <p-panel
                [toggleable]="true"
                styleClass="mb-3"
                collapsed="true"
                collapseIcon="pi pi-chevron-right"
                expandIcon="pi pi-chevron-down"
              >
                <p-header class="w-100 ml-0 p-2 panel-header">
                  <section
                    class="flex align-items-center justify-content-between"
                  >
                    <section class="flex align-items-center">
                      <div class="drag-handle mr-3">
                        <i class="pi pi-list"></i>
                        <span class="handle"></span>
                      </div>
                      <h3 class="mr-3">{{ formGroupIndex + 1 }}.</h3>
                      <div class="field mr-3 mb-0">
                        <label>Naziv operacije</label>
                        <p-dropdown
                          #operationId
                          [options]="allOperations"
                          (onChange)="onChangeOperation($event, formGroupIndex)"
                          optionLabel="name"
                          placeholder="Izaberi operaciju"
                          formControlName="operation_id"
                          optionValue="id"
                        ></p-dropdown>
                      </div>
                      <div class="field mr-3 mb-0">
                        <label>Pripremno vreme</label>
                        <input
                          type="text"
                          formControlName="prep_time"
                          (input)="
                            updateOperationFields(operations, ['prep_time'])
                          "
                          pInputText
                        />
                      </div>
                      <div class="field mr-3 mb-0">
                        <label>Vreme operacije</label>
                        <input
                          type="text"
                          formControlName="operation_time"
                          (input)="
                            updateOperationFields(operations, [
                              'operation_time'
                            ])
                          "
                          pInputText
                        />
                      </div>
                      <div class="field mr-3 mb-0">
                        <label>Vreme do sl. operacije</label>
                        <input
                          type="text"
                          formControlName="next_op_time"
                          (input)="
                            updateOperationFields(operations, ['next_op_time'])
                          "
                          pInputText
                        />
                      </div>
                    </section>

                    <button
                      class="second-btn small-btn"
                      type="button"
                      pTooltip="Ukloni"
                      tooltipPosition="top"
                      (click)="removeOperation(formGroupIndex)"
                    >
                      <i class="pi pi-trash"></i>
                    </button>
                  </section>
                </p-header>

                <section
                  *ngIf="
                    getSuboperationsControls(formGroupIndex).controls.length
                  "
                >
                  <ul
                    [dragula]="'SUBOPERATIONS' + formGroupIndex"
                    formArrayName="suboperations"
                    [(dragulaModel)]="
                      getSuboperationsControls(formGroupIndex).controls
                    "
                  >
                    <li
                      *ngFor="
                        let suboperations of getSuboperationsControls(
                          formGroupIndex
                        ).controls;
                        let i = index
                      "
                      [formGroupName]="i"
                    >
                      <section
                        class="flex align-items-center justify-content-between m-3 ml-3"
                      >
                        <section class="flex align-items-center">
                          <h3 class="mr-3">{{ i + 1 }}.</h3>
                          <div class="field mr-3">
                            <label>Naziv podoperacije</label>
                            <p-dropdown
                              [options]="findOperation(operationId.value)"
                              (onChange)="
                                onChangeSuboperation(
                                  $event,
                                  operationId.value,
                                  formGroupIndex,
                                  i,
                                  operations,
                                  [
                                    'prep_time',
                                    'operation_time',
                                    'next_op_time'
                                  ]
                                )
                              "
                              optionLabel="name"
                              placeholder="Izaberi podoperaciju"
                              formControlName="suboperation_id"
                              optionValue="id"
                            ></p-dropdown>
                          </div>
                          <div class="field mr-3">
                            <label>Pripremno vreme</label>
                            <input
                              type="text"
                              formControlName="prep_time"
                              (input)="
                                updateOperationFields(operations, ['prep_time'])
                              "
                              pInputText
                            />
                          </div>
                          <div class="field mr-3">
                            <label>Vreme operacije</label>
                            <input
                              type="text"
                              formControlName="operation_time"
                              (input)="
                                updateOperationFields(operations, [
                                  'operation_time'
                                ])
                              "
                              pInputText
                            />
                          </div>
                          <div class="field mr-3">
                            <label>Vreme do sl. operacije</label>
                            <input
                              type="text"
                              formControlName="next_op_time"
                              (input)="
                                updateOperationFields(operations, [
                                  'next_op_time'
                                ])
                              "
                              pInputText
                            />
                          </div>
                        </section>

                        <button
                          class="second-btn small-btn"
                          type="button"
                          pTooltip="Ukloni"
                          tooltipPosition="top"
                          (click)="removeSuboperation(i, formGroupIndex)"
                        >
                          <i class="pi pi-trash"></i>
                        </button>
                      </section>
                    </li>
                  </ul>
                </section>

                <button
                  class="second-btn ml-6"
                  type="button"
                  (click)="addSuboperation(formGroupIndex)"
                >
                  Dodaj podoperaciju
                </button>
              </p-panel>
            </li>
          </ul>
          <button
            class="second-btn mt-1"
            type="button"
            (click)="addOperation()"
          >
            Dodaj operaciju
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
